import { ThunkResult } from '../../store'
import { replaceResult, replaceResultData } from './CustomLabels.slice'
import customLabelApi from '../../apis/customLabel.api'
import customLabelService from '../../services/customLabel.service'
import storageService from '../../services/storage.service'

export function paginate (): ThunkResult<void> {
  return (dispatch, getState) => {
    const { page, limit, search } = getState().items
    const { sortBy } = getState().customLabels
    const params = { page, limit, search, sortBy }

    const searchStr = storageService.get('customLabelSearch')
    const pageStr = storageService.get('customLabelPage')
    const limitStr = storageService.get('customLabelLimit')
    const sortingStr = storageService.get('customLabelSorting')

    if (pageStr != '' && pageStr != null && pageStr != undefined) { params.page = pageStr }

    if (searchStr != '' && searchStr != null && searchStr != undefined) { params.search = searchStr }

    if (limitStr != '' && limitStr != null && limitStr != undefined) { params.limit = limitStr }

    if (sortingStr != '' && sortingStr != null && sortingStr != undefined) { params.sortBy = sortingStr }

    customLabelApi.paginate(params, paginate => {
      if (!paginate) return
      dispatch(replaceResult(paginate))
    })
  }
}

export function deleteCustomLabel (id: number): ThunkResult<void> {
  return (dispatch, getState) => {
    customLabelApi.delete(id, customLabel => {
      if (!customLabel) return
      const { result } = getState().customLabels
      const data = customLabelService.delete(result.data, id)
      dispatch(replaceResultData(data))
    })
  }
}
